import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(7.25),
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(3),
  },
  '& .FHSBackBtn': {
    padding: theme.spacing(1.5, 0),
    fontWeight: '600',
    marginBottom: theme.spacing(3),
    minHeight: 'unset',
  },
  '& .FHSTitleContainer': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
  '& .FHSDescription': {
    maxWidth: theme.typography.pxToRem(728),
  },
}));

export default StyledBox;
